import { entireAudioEnhancer } from './enhancers';

export const {
  entireAudioInstanceIdSelector,
  uploadStatusSelector,
  uploadProgressSelector,
} = entireAudioEnhancer.selectors;
